// extracted by mini-css-extract-plugin
module.exports = {"inner":"cd01fbf7b5--inner--GTm4J","title":"cd01fbf7b5--title--TCrIS","values":"cd01fbf7b5--values--WGitm","row":"cd01fbf7b5--row--wOTlO","text":"cd01fbf7b5--text--rHGkH"};